var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechat-wrap"},[_c('van-dialog',{attrs:{"title":"微信昵称复制成功","cancelButtonText":"我知道了","showCancelButton":true,"showConfirmButton":false,"cancelButtonColor":"#515A6E"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',{staticClass:"notice"},[_vm._v("您可以打开微信搜索用户")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }